define('all/footer',['jquery', 'all/dialog', 'all/pixel-tracking', 'all/template'], function($, dialog, pt) {
	'use strict';
	var footer = {};

	function setupAuthoritiesLinks($footer) {
		$footer.find('.authorities a').click(function(event) {
			event.preventDefault();
			var href = $(this).attr('href');
			var title = $(this).attr('title');
			var windowFeatures = 'location=yes,scrollbars=yes,directories=yes,menubar=yes,resizeable=yes,status=yes,toolbar=yes';
			if (title === 'Lga') {
				windowFeatures += ',width=1024,height=768';
			}
			if (title === 'CuracaoLicense') {
				windowFeatures += ',width=640,height=800';
			}
			window.open(href, title, windowFeatures);
		});
	}

	function setupPopups($footer) {
		$footer.find('a[data-popup]').click(function(event) {
			event.preventDefault();
			dialog.load('info', $(this).data('popup'));
		});
	}

	function setupLanguageSelector($footer) {
		var $languageSelector = $footer.find('.language-selector');

		$.getJSON('/pp?flow=GetLanguageLinks', {location: window.location.pathname.split('/'), hash: ''})
			.success(function(languages) {
				if (languages.length >= 1) {
					// More languages available.
					$languageSelector.show();
				}
			});

		$languageSelector.find('.selected').click(function() {
			var $this = $(this),
				hash = window.location.hash;
			hash = hash.split('/')[0];
			while (hash.length > 0 && '#!'.indexOf(hash.substr(0, 1)) !== -1) {
				hash = hash.substr(1);
			}
			$.getJSON('/pp?flow=GetLanguageLinks', {location: window.location.pathname.split('/'), hash: hash})
				.success(function(languages) {
					var $changeLanguage = $footer.find('.change-language');
					$changeLanguage.applyTemplate(languages);
					$changeLanguage.find('a[data-locale]').click(function(event) {
						event.preventDefault();
						var $link = $(this);
						$.ajax({ url: '/pp?flow=empty&locale=' + $link.data('locale'), async: false})
							.success(function() {
								window.location.href = $link.attr('href');
							});
					});
				});
			$this.parent().toggleClass('expanded');
		});
	}

	function initFooter() {
		if (window.top !== window.self) {
			return;
		}
		var $footer = $('footer#cnt-footer');

		setupPopups($footer);
		setupAuthoritiesLinks($footer);
		setupLanguageSelector($footer);

	}

	footer.pixelTrack = function(page) {
		pt.addPixelTrack(page);
	};

	footer.show = function() {
		$('footer#cnt-footer').fadeIn();
	};

	$(function(){
		initFooter();
	});

	return footer;
});

